import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { vendorFields } from './common/vendorFields';
import { productFields, purchasedMaterialFields } from './common/productFields';
import { msg } from '@lingui/core/macro';
import {
  applicationOfCascadingPrincipleField,
  isBiologicalField,
  sustainableSourcingSchemeField,
  isSecondaryField,
  materialWeightField,
  materialField,
} from './common/consumerGoodsFields';
import { massUnitField } from './common/sharedFields';
import { wasteTreatmentField } from './common/wasteFields';

export const consumerGoodsPackagingMaterialMetadata = {
  displayName: msg({
    message: 'Packaging',
    context: 'Activity data schema name for packaging',
  }),
  fields: {
    ...coreFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    application_of_cascading_principle: applicationOfCascadingPrincipleField,
    is_biological: isBiologicalField,
    is_secondary: isSecondaryField,
    packaging_material: materialField,
    quantity: materialWeightField,
    sustainable_sourcing_scheme: sustainableSourcingSchemeField,
    unit: massUnitField,
    waste_treatment: wasteTreatmentField,
  },
} as const satisfies BatMetadataConfigEntry;
